var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('EnrollFingerprints',{model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }